import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getErrorMessage } from '~web/i18n/error-mapper';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { CloseIcon } from '~web/view/components/ui/icon/close-icon.component';
import { Span } from '~common/components/span.component';

export interface Props {
  error: Error | string;
  onClose?: () => void;
}

export const DataError: React.FunctionComponent<Props> = ({
  error,
  onClose,
  children,
  ...renderProps
}) => {
  const [isOpened, setOpened] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setOpened(true);
  }, [error]);

  const handleClose = (): void => {
    setOpened(false);

    if (onClose) {
      onClose();
    }
  };

  if (!error) {
    return null;
  }

  return (
    isOpened && (
      <Container {...renderProps}>
        <Content>
          {children || (
            <ErrorText>{typeof error === 'string' ? error : getErrorMessage(t, error)}</ErrorText>
          )}
        </Content>
        <CloseIconWithMargin onClick={handleClose} />
      </Container>
    )
  );
};

const Container = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: ${(props): number => props.theme.zIndex.error};
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 25px;
  background-color: ${(props): string => props.theme.colors.error};
`;

const Content = styled(Column)`
  flex: 1;
`;

const ErrorText = styled(Span)`
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.3px;
  white-space: pre-wrap;
`;

const CloseIconWithMargin = styled(CloseIcon)`
  margin-left: 24px;
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/components/core/data-error.component.tsx